/**
 * Zod schema for the `codeRequests` collection (ADR-030).
 *
 * Created by the `requestInvitationCode` callable when an unauthenticated
 * user requests a code. Organizers fulfill or dismiss manually via the admin
 * portal. Only 'pending' rows may transition; 'fulfilled' rows are the durable
 * signal checkEmailStatus routes on (ADR-154) and must never be rewritten.
 * Dismissal is non-sticky: the same email may request again, creating a fresh
 * 'pending' row (ADR-170).
 */

import { z } from 'zod';
import type { TimestampLike } from '../types/common';

export const codeRequestStatusSchema = z.enum([
  'pending',
  'fulfilled',
  'dismissed',
]);

export const codeRequestDocumentSchema = z.object({
  email: z.string(),
  requestedAt: z.custom<TimestampLike>(),
  status: codeRequestStatusSchema,
  // Audit stamps written on the corresponding status transition. Absent on
  // rows that predate the dismiss feature and on 'pending' rows.
  fulfilledAt: z.custom<TimestampLike>().optional(),
  fulfilledByUid: z.string().optional(),
  dismissedAt: z.custom<TimestampLike>().optional(),
  dismissedByUid: z.string().optional(),
});
